import React from 'react'
import { ArrowRight } from "lucide-react";
import { Link } from 'react-router-dom'
import './Card.css'

const Card = ({title, description, path, className, img}) => {
  return (
   <Link to={path } className='card-empezar'>
     <div className={`card-select ${className}`}>
      <h2 className='title-card'>{title}</h2>
      <div className='container-description'>
        <p className='parag'>{description}</p>
        <img src={img} alt="Tests" className='img-card'/>
        {/* <p className='btn-ir'>Ir <ArrowRight width={20}/></p> */}
      </div>
     </div>
     </Link>
  )
}

export default Card
